export class ChangeOrderCustomerInput {
    orderId?: number;
    customerId: number;
    userId?: number;
}